module.exports = __webpack_public_path__ + "static/media/05.b2666693.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/SectionTwo/expos/05.png
// module id = 176
// module chunks = 0